// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__tAQN4","col":"CardReaderDesc_col__2Nxby","label":"CardReaderDesc_label__3-VxQ"};